/**
 * Validates the `data-position` script attribute and resolves it to a
 * `WidgetPosition`. Falls back to the default when the attribute is missing
 * or unrecognised so the widget always lands in a usable layout. Matching
 * is lenient — surrounding whitespace is trimmed and casing is ignored, so
 * `Inline`, ` BOTTOM-LEFT `, `Bottom-Right` all parse.
 */

import { warnLog } from "../config";
import { defaultWidgetPosition, WidgetPosition } from "./constants";

const validPositions = new Set<string>(Object.values(WidgetPosition));

export function parsePosition(raw: string | undefined): WidgetPosition {
  if (raw === undefined) return defaultWidgetPosition;

  const normalised = raw.trim().toLowerCase();
  if (validPositions.has(normalised)) return normalised as WidgetPosition;

  warnLog(
    `Invalid data-position "${raw}". ` +
      `Expected one of ${Object.values(WidgetPosition).join(", ")}. ` +
      `Falling back to "${defaultWidgetPosition}".`,
  );
  return defaultWidgetPosition;
}
